var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="alert alert-warning alert-dismissible"role="alert"> <button type="button pull-right"class="close"data-dismiss="alert"aria-label="Close"> <span aria-hidden="true">&times;</span> </button> <p> <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko --> </p> </div>';
}
return __p;
};
